import basic_time_spinner_vue_vue_type_script_setup_true_lang_default from "./basic-time-spinner.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/time-picker/src/time-picker-com/basic-time-spinner.vue
var basic_time_spinner_default = basic_time_spinner_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { basic_time_spinner_default as default };
//# sourceMappingURL=basic-time-spinner.mjs.map